import { Container } from '@mui/material'
import clsx from 'clsx'
import React from 'react'

import styles from './styles.module.scss'
import { UContainerProps } from './type'

export const UContainer = ({ children, maxWidth = 'lg' }: UContainerProps) => {
  return (
    <Container maxWidth={maxWidth}>
      <div className={clsx(styles['container'])}>{children}</div>
    </Container>
  )
}
